import clsx from 'classnames';

import styles from './ProductSkeleton.module.scss';

export const ProductSkeleton = () => {
	return (
		<div className={styles.productSkeleton}>
			<div
				className={clsx(styles['productSkeleton--image'], styles['productSkeleton--loadingEffect'])}
			/>
			<div
				className={clsx(styles['productSkeleton--price'], styles['productSkeleton--loadingEffect'])}
			/>
			<div
				className={clsx(
					styles['productSkeleton--description'],
					styles['productSkeleton--loadingEffect']
				)}
			/>
		</div>
	);
};
